module.exports = __webpack_public_path__ + "img/05-title-02.d4418373.png";